import styled from 'styled-components';
import { InterestedBoxStyled } from '../InterestedBoxStyled';
import { rem } from 'polished';
export const InterestedBoxStyledDS = styled(InterestedBoxStyled)`
    .btn-section {
        button {
            min-height: ${rem('50px')};
            height: 100%;
        }
    }

    .links-section {
        .section {
        }

        .legal-text {
            color: ${({ theme }) => theme.colors.grey29};
            font-size: ${rem(14)};
            line-height: ${rem(16)};
        }
    }

    .dealerShare {
        &:hover,
        &:focus-visible {
            color: ${({ theme }) => theme.colors.primary};
            border-color: ${({ theme }) => theme.colors.primary};
        }
    }

    .reinsurance {
        color: ${({ theme }) => theme.colors.black};
        line-height: 1;
        font-size: ${rem('16px')};
        border-bottom: 1px solid ${({ theme }) => theme.colors.black};
    }
`;
